<template>
  <v-dialog max-width="600px" v-model="dialog">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon
            color="orange"
            v-on="{ ...tooltip, ...dialog }"
            @click="getCartAddress"
            ><v-icon>label</v-icon>
          </v-btn>
        </template>
        <span>Change address</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <h2>Order Address</h2>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3" ref="form">
          <v-textarea
            v-model="cartAddress"
            label="Address"
            prepend-icon="email"
          ></v-textarea>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirmAddressChange"
            class="success mx-1 mt-3"
            :loading="loadingConfirm"
            ><v-icon>done</v-icon><span> Confirm change</span></v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  props: {
    cartId: {
      type: String,
    },
  },
  data() {
    return {
      cartAddress: "",
      dialog: false,
      loadingConfirm: false,
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    async getCartAddress() {
      let tmpAddress = await cartApi.getPaymentForCart(this.cartId);
      this.cartAddress = this.prepareAddress(tmpAddress.customerAddress);
    },
    async copyAddress() {
      let copyRes = false;
      await navigator.clipboard.writeText(this.cartAddress).then(function() {
        copyRes = true;
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
      if (copyRes) this.$toast("Copied address");
      this.dialog = false;
    },
    prepareAddress(address) {
      let updatedAddress = address.replace(/<br>/g, "\n");
      updatedAddress = updatedAddress + "\n\n";
      return updatedAddress;
    },
    confirmAddressChange() {
      if (this.$refs.form.validate()) {
        this.loadingConfirm = true;
        let updateBody = {
          cartId: this.cartId,
          address: this.cartAddress,
        };
        cartApi.postUpdatePaymentInformation(updateBody).then(() => {
          this.loadingConfirm = false;
          this.dialog = false;
          this.$emit("addressChanged");
        });
      }
    },
  },
};
</script>
